var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "end icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 140 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 9.66048C4.71875 9.25918 5.04407 8.93386 5.44537 8.93386H12.7383L11.3214 7.51645C11.0377 7.23264 11.0378 6.77257 11.3216 6.48886C11.6054 6.20514 12.0654 6.20522 12.3492 6.48903L15.006 9.14677C15.2873 9.42818 15.29 9.88352 15.012 10.1682L12.3551 12.8885C12.0747 13.1756 11.6147 13.181 11.3276 12.9006C11.0405 12.6202 11.0351 12.1602 11.3155 11.8731L12.7668 10.3871H5.44537C5.04407 10.3871 4.71875 10.0618 4.71875 9.66048Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.731d5220d051f83465381dcfb2c96601.svg";
export { ForwardRef as ReactComponent };